import { type OpsPermissions, OPS_PERMISSIONS_NONE } from '../types/ops-permissions'
import { useSession } from './useAppSession'

const OPS_PERMISSIONS_ALL: OpsPermissions = {
  overview: true, activity: true,
  orders_sendto: true, orders_upload: true, orders_requests: true,
  ops_outbound: true, ops_receive: true, ops_complete: true, ops_tickets: true, ops_incoming: true,
  inv_overview: true, inv_today: true, inv_fifo: true, inv_picking: true, inv_shortage: true,
  inv_reserved: true, inv_stock: true, inv_movements: true, inv_adjust: true,
}

export function useOpsPermissions(): OpsPermissions {
  const session = useSession()
  if (!session) return { ...OPS_PERMISSIONS_NONE }

  // admin and owner always have full access
  if (session.tenantRole === 'admin' || session.tenantRole === 'owner') {
    return { ...OPS_PERMISSIONS_ALL }
  }

  // member role: use explicitly assigned ops permissions; null = no access
  if (!session.opsPermissions) return { ...OPS_PERMISSIONS_NONE }
  return { ...OPS_PERMISSIONS_NONE, ...session.opsPermissions } as OpsPermissions
}
